import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  USDT,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P2 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { NodeImage, NodeStyled } from './Node.styled';

export const Node = ({ image, title, price, condensed }: any) => {
  return (
    <NodeStyled>
      <div>
        <NodeImage condensed={condensed} image={image} />

        <Flexed column between>
          <div>
            <H4 mb='4' color={colors.neutral0}>
              {title}
            </H4>

            <H3 bold color={colors.neutral0}>
              {formatUSD(price)} USDT
            </H3>
          </div>
        </Flexed>
      </div>
    </NodeStyled>
  );
};
